import React, { useState } from 'react';
import { Box } from '@mui/material';
import DialogTemplate from '../../../layout/DialogTemplate';
import Button from '../../../common/inputs/Button';
import InputField from '../../../common/inputs/InputField';
import { adminApi, AdminOrg } from '../../../../services/api/admin';
import { useToast } from '../../../../contexts/ToastContext';

interface CreateOrgDialogProps {
  open: boolean;
  onClose: () => void;
  onCreated: (org: AdminOrg) => void;
}

const CreateOrgDialog: React.FC<CreateOrgDialogProps> = ({ open, onClose, onCreated }) => {
  const [displayName, setDisplayName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showSuccess, showError } = useToast();

  const handleClose = () => {
    setDisplayName('');
    onClose();
  };

  const handleSave = async () => {
    if (!displayName.trim()) return;
    setIsSubmitting(true);
    try {
      const org = await adminApi.createOrganisation({ display_name: displayName.trim() });
      showSuccess(`Mandant "${org.name}" wurde angelegt`);
      onCreated(org);
      handleClose();
    } catch {
      showError('Mandant konnte nicht angelegt werden');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <DialogTemplate
      open={open}
      onClose={handleClose}
      title="Neuen Mandanten anlegen"
      maxWidth="sm"
      actions={
        <>
          <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
            Abbrechen
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isSubmitting || !displayName.trim()}
          >
            {isSubmitting ? 'Anlegen...' : 'Anlegen'}
          </Button>
        </>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1 }}>
        <InputField
          label="Anzeigename"
          value={displayName}
          onChange={setDisplayName}
          placeholder="z.B. Windpark GmbH Nord"
          required
          size="small"
        />
      </Box>
    </DialogTemplate>
  );
};

export default CreateOrgDialog;
